// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import { Route } from 'react-router';
import { IndexRoute } from 'react-router';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import ReportsRoot from 'modules/Reports/Izenda.ReportsRoot';
import ReportList from 'modules/Reports/ReportList/Izenda.ReportList';
import ReportViewer from 'modules/Reports/ReportViewer/Izenda.ReportViewer';
import ReportEditor from 'modules/Reports/ReportViewer/Izenda.ReportEditor';

const reportRoutes = () => {
  const ROUTE = routeUtils.getConfigRoute('Report');
  const LIST_ROUTE = routeUtils.getConfigRoute('Report', 'List');
  const VIEW_ROUTE = routeUtils.getConfigRoute('Report', 'View');
  const EDIT_ROUTE = routeUtils.getConfigRoute('Report', 'Edit');
  const IFRAME_ROUTE = routeUtils.getConfigRoute('Report', 'IframeExport');

  return (
    <Route
      path={ROUTE.path}
      component={ReportsRoot.Container}>
      <IndexRoute component={ReportList} />
      <Route name={LIST_ROUTE.name} path={LIST_ROUTE.path} component={ReportList} />
      <Route name={VIEW_ROUTE.name} path={VIEW_ROUTE.path} component={ReportViewer} />
      <Route name={EDIT_ROUTE.name} path={EDIT_ROUTE.path} component={ReportEditor} />
      <Route name={IFRAME_ROUTE.name} path={IFRAME_ROUTE.path} component={ReportViewer} />
    </Route>
  );
};

export default reportRoutes;




// WEBPACK FOOTER //
// ./ui/modules/Reports/Izenda.ReportRoutes.js